import { ReactNode } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { withRouter } from 'react-router';
import SequenceSingleHeader from './sequence-single-header';
import { RootState } from '../../../../store/root-reducer';
import {
  getContactStatusCountRequest,
  getSequenceContactListRequest,
  getSequenceRequest,
  getSubsequencesRequest,
  pauseResumeSequenceRequest,
  renameSequenceRequest,
} from '../../extra-actions';
import { SequenceAction, SortOrder } from '../../enums';
import {
  ContactListParams,
  ContactsPagination,
  GetSequencesQueryParams,
  SequenceIdRouteComponentProps,
} from '../../types';
import { upgradeOnboardingStepRequest } from '../../../home/extra-actions';
import { UpgradeOnboardingStepPayload } from '../../../home/types';
import { connectEmailAccountRequest } from '../../../email-accounts/extra-actions';
import { EmailAccountMethod } from '../../../email-accounts/enums/email-account';
import {
  changeContactPagination,
  setIsPauseResumeSequence,
} from '../../sequence-slice';

const mapStateToProps = (state: RootState) => ({
  renameSequenceRequestStatus: state.sequence.renameSequenceRequest.status,
  renameSequenceRequestMessage: state.sequence.renameSequenceRequest.message,
  renameSequenceRequestError: state.sequence.renameSequenceRequest.error,
  pauseResumeSequenceRequestStatus:
    state.sequence.pauseResumeSequenceRequest.status,
  pauseResumeSequenceRequestMessage:
    state.sequence.pauseResumeSequenceRequest.message,
  pauseResumeSequenceRequestError:
    state.sequence.pauseResumeSequenceRequest.error,
  title: state.sequence.sequence?.title,
  progress: state.sequence.sequence?.progress,
  isStepsListEmpty: state?.sequence?.sequence?.steps?.length === 0,
  sequenceId: state.sequence.sequence?.id,
  isContactsEmpty: !state.sequence.contactStepFilterCount.totalContacts,
  meta: state.home.meta,
  connectEmailAccountRequestStatus:
    state.emailAccount.connectEmailAccountRequest.status,
  authUrl: state.emailAccount.authUrl,
  getUserSettingRequestStatus: state.home.getUserSettingsRequest.status,
  role: state.home.role,
  subscriptionPlan: state.home.subscription?.planCode,
  pausedReasonIdentifier: state.sequence.sequence?.pausedReasonIdentifier,
  remainingEmailSentLimit: parseInt(
    state.home.getPostLoadMetaResponse?.accountUsageQuotaRemaining?.[
      'EMAIL.SEND'
    ],
    10,
  ),
  sequence: state.sequence.sequence,
  sequenceStatsCounts: state.sequence.sequenceStatsCounts,
  subscriptionDetails: state.home.subscription,
  isPauseResumeSequence: state.sequence.isPauseResumeSequence,
  verified: state.home.verified,
  sequenceCreationSource: state.sequence.sequence?.creationSource,
});

const mapDispatchToProps = {
  sendGetSequenceRequest: (sequenceId: number) =>
    getSequenceRequest(sequenceId),

  sendGetSubsequencesRequest: (
    params: GetSequencesQueryParams & { sequenceId: number },
  ) => getSubsequencesRequest(params),

  sendRenameSequenceRequest: (sequenceId: number, title: string) =>
    renameSequenceRequest({ sequenceId, title }),
  sendPauseResumeSequenceRequest: (
    sequenceId: number,
    action: SequenceAction,
    shouldPauseSubSequences?: boolean,
  ) =>
    pauseResumeSequenceRequest({ sequenceId, action, shouldPauseSubSequences }),
  sendUpgradeOnboardingStepRequest: (payload?: UpgradeOnboardingStepPayload) =>
    upgradeOnboardingStepRequest(payload),
  sendConnectEmailAccountRequest: (
    method: EmailAccountMethod,
    emailAccountId?: number,
  ) => connectEmailAccountRequest({ method, emailAccountId }),
  changePagination: (pagination: ContactsPagination) =>
    changeContactPagination(pagination),
  sendGetSequenceContactListRequest: (
    sequenceId: number,
    params: ContactListParams,
  ) =>
    getSequenceContactListRequest({
      sequenceId: sequenceId?.toString(),
      ...params,
      sortOrder: SortOrder.Asc,
    }),
  sendGetContactStatusCountRequest: (
    sequenceId: number,
    paginationOption: ContactsPagination,
  ) =>
    getContactStatusCountRequest({
      sequenceId: sequenceId?.toString(),
      ...paginationOption,
    }),
  setIsPauseResumeSequence: (payload: boolean) =>
    setIsPauseResumeSequence(payload),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector> &
  SequenceIdRouteComponentProps & {
    currentTab: string;
    t: (x: string) => ReactNode;
  };

export default withRouter(connector(SequenceSingleHeader));
